// Copyright © 2024 The Things Network Foundation, The Things Industries B.V.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

const selectSearchStore = state => state.search

export const selectSearchResults = state => selectSearchStore(state).results
export const selectSearchQuery = state => selectSearchStore(state).query
export const selectIsSearchOpen = state => selectSearchStore(state).searchOpen
export const selectSearchScope = state => selectSearchStore(state).scope
export const selectSearchLabelIdContains = state => selectSearchStore(state).label_id_contains
